import React from 'react';
import RootAPP from './routes/routes';
import './i18n';
import { ThemeProvider } from './themeContext';
import { Toaster } from 'sonner';

const App = () => {

  return (
    <>
      <ThemeProvider>
        <RootAPP />
      </ThemeProvider>
      <Toaster position="top-right" richColors duration={2000} expand closeButton/>
    </>
  );
}

export default App;
